import { createContext, useContext } from 'react'

type RichCardLinkContextValue = {
  openInNewTab: boolean
}

const RichCardLinkContext = createContext<RichCardLinkContextValue>({ openInNewTab: false })

export const RichCardLinkProvider = RichCardLinkContext.Provider

export const useRichCardLinkContext = () => useContext(RichCardLinkContext)
